import MappingOrigin from "./mappingOrigin";
import * as _ from 'lodash';
import {ModelType} from "~/enums/modelType";
import SObjectDescribed from "~/models/salesforce/sObjectDescribed";
import {ISSchema} from "~/interfaces/salesforceInterfaces";
import SObjectChildRelationship from "~/models/salesforce/sObjectChildRelationship";
import SObjectReferenceField from "~/models/salesforce/SObjectReferenceField";
import MappingOriginOptionSalesforce from "~/models/mapping/mappingOriginOptionSalesforce";

export default class MappingOriginSalesforce extends MappingOrigin {
  readonly friendly_type = ModelType.SObject;
  _salesforceSchema: ISSchema

  external_connection_id: string;
  external_connection_environment_type: string;
  root_object_name: string;
  model_object_names: string[];

  get rootIdentifier(): string {
    return this.root_object_name
  }

  set rootIdentifier(value: string) {
    this.root_object_name = value;
  }

  get modelIdentifiers() {
    return this.model_object_names || [];
  }

  set modelIdentifiers(value) {
    this.model_object_names = value;
  }

  get relationshipModels() {
    return this.modelIdentifiers.reduce((rels, id) => {
      let rel
      rel = this.root.objectDescribed.childRelationships.find(r => r.relationshipName === id)
      if (rel) {
        rels.push(new SObjectChildRelationship(rel))
        return rels
      }
      rel = this.root.objectDescribed.fields.find(r => r.relationshipName === id)
      if (rel) {
        rels.push(new SObjectReferenceField(rel))
        return rels
      }
      return rels
    }, [])
  }

  get root(): SObjectDescribed {
    return new SObjectDescribed(this._salesforceSchema.object_describes, this.root_object_name)
  }

  static availableOptions(salesforceSchema: ISSchema): MappingOriginOptionSalesforce[] {
    let options: MappingOriginOptionSalesforce[] = [];
    const rootObjectName = salesforceSchema.root_object_name;
    const objectDescribes = salesforceSchema.object_describes;
    const rootObjectSchema = objectDescribes[rootObjectName];

    // likely need to save both the relationshipName and the field properties from the relationshipData
    // might also need the type 'multi' saved as well
    rootObjectSchema['childRelationships'].forEach(function (relationshipData) {
      const {relationshipName} = relationshipData;
      if (relationshipName) {
        options.push(new MappingOriginOptionSalesforce({origin: salesforceSchema, sObjectSource: relationshipName, type: 'multi'}))
      }
    });

    // likely need to save the relationshipName and the name properties from the relationshipData
    // might also need the type 'single' saved as well
    rootObjectSchema['fields'].forEach(function (fieldData) {
      const {type, relationshipName} = fieldData;
      if (type === 'reference') {
        options.push(new MappingOriginOptionSalesforce({origin: salesforceSchema, sObjectSource: relationshipName, type: 'single'}))
      }
    });

    options = _.sortBy(options, 'title');
    options.unshift(new MappingOriginOptionSalesforce({origin: salesforceSchema, sObjectSource: rootObjectName, type: 'single'}));

    return options;
  }

  get availableOptions(): MappingOriginOptionSalesforce[] {
    return MappingOriginSalesforce.availableOptions(this._salesforceSchema);
  }
}
